import { render } from "./search-bar-wrapper.vue?vue&type=template&id=27ca1509&ts=true"
import script from "./search-bar-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./search-bar-wrapper.ts?vue&type=script&lang=ts&external"

import "./search-bar-wrapper.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__